export const FB_ID = 443474612894785;
export const G_ID = '669934516132-enc7r3un0akvna7inerpgj3un0c6kisl.apps.googleusercontent.com';
